module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAA4UlEQVQoFWNgIBMwgvRtlNY88P8/gz0xZjAyMhz0f3rdgQmkmFhNyGrBGomxCV0NURp1W2oYZEP8UPQS1KhVVcTALiTA8HjtZtwazedPZeCSlYYrUM1JZeDTUGU4m1cBDgi4BJCBYuPduYsZLJbMYuCSl2VQiItgEHOwYTiVVsDw/88fZD1gNguyyJsjJxguVjQwWK+ax/Dz9VuGY+FJDP9+/ERWAmejaASJvj1+muFkQjbD9+cvGf58/QZXiM7A0AhS8On6LXR1GHwUP2LI4hEAawQlIzxqUKRIUYuiEcYBALDjPHrB16mGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/selected_icon.png
// module id = 696
// module chunks = 1